import { ROUTE_CATALOG } from "../js/route-catalog.js";

export const DEFAULT_LOCALE = "en";
export const LOCALES = ["es", "en"];

export const CANONICAL_SLUGS = Object.fromEntries(
  ROUTE_CATALOG.map((route) => [route.canonical, route.slugs])
);

const slugToCanonical = {};
for (const [canonical, slugs] of Object.entries(CANONICAL_SLUGS)) {
  for (const [locale, slug] of Object.entries(slugs)) {
    slugToCanonical[`${locale}:${slug}`] = canonical;
  }
}

export function getLocale(pathname) {
  const first = (pathname || "/").split("/").find(Boolean) ?? "";
  return LOCALES.includes(first) ? first : DEFAULT_LOCALE;
}

export function parseLocalePath(pathname) {
  const first = (pathname || "/").split("/").find(Boolean) ?? "";
  if (!LOCALES.includes(first)) {
    return { locale: DEFAULT_LOCALE, canonical: null };
  }
  const locale = first;
  const afterLocale = pathname.slice(1 + locale.length) || "/";
  const slug = afterLocale === "/" ? "" : afterLocale.replace(/^\//, "").replace(/\/+$/, "");
  const canonical = slug === "" ? "/" : slugToCanonical[`${locale}:${slug}`] ?? null;
  return { locale, canonical };
}

export function localePath(locale, canonicalPath) {
  const slugs = CANONICAL_SLUGS[canonicalPath];
  if (!slugs) return `/${locale}/`;
  const slug = slugs[locale];
  return slug ? `/${locale}/${slug}/` : `/${locale}/`;
}

export function getAlternateUrl(pathname, targetLocale) {
  const { canonical } = parseLocalePath(pathname);
  if (!canonical) return `/${targetLocale}/`;
  return localePath(targetLocale, canonical);
}
